import { Button, Checkbox, Spinner, Text } from "src/components";
import { Util } from "src/utils/Util";
import { BillFacade } from '../../controller/facades/bill.facade';
import BillForm from "../components/BillForm/BillForm";
import './Bill.scss';

/**
 *
 */
const BillPage = (): JSX.Element => {
  const { invoiceStatus, policyNumber, currentInvoice, billList, formVisible, setFormVisible, createInvoiceByForm,
    creating, taxRegimes, onSelectBillInfo, currentBillInfo, createInvoiceByBillInfo } = BillFacade.useInvoice();
  return (
    <div className={`bill${formVisible ? ' bill--hide-overflow' : ''}`}>
      <div className="bill__content">
        {
          invoiceStatus && taxRegimes && taxRegimes.length > 0 ?
            <>
              {
                invoiceStatus.isAvailable() && currentInvoice &&
                <>
                  <div className="bill__content__invoice">

                    <section className="bill__content__invoice__section bill__content__invoice__section--left">
                      <div className="bill__content__invoice__section__header">
                        <span style={{ backgroundImage: `url(${Util.ASSET.PAYMENT_CARD})` }}></span>
                        <h2>Resumen de la compra</h2>
                      </div>

                      <div className="bill__content__invoice__section__content">
                        <div className="bill__content__invoice__section__content__list">
                          <div className="bill__content__invoice__section__content__list__row bill__content__invoice__section__content__list__row--header">
                            <Text type="paragraph" bold>Descripci&oacute;n</Text>
                            <Text type="paragraph" bold align="center">IVA</Text>
                            <Text type="paragraph" bold align="right">Precio</Text>
                          </div>

                          {
                            currentInvoice.premiumList.map(
                              (premium, index) => {
                                return (
                                  <div className="bill__content__invoice__section__content__list__row">
                                    <div className="bill__content__invoice__section__content__list__row__description">
                                      <Text type="label" bold block className="bill__content__invoice__section__content__list__row__description__name">{premium.description}</Text>
                                      <Text type="label">{premium.policyNumber}</Text>
                                    </div>

                                    <Text type="label" align="center">
                                      {Util.TRANSFORM.CURRENCY.MXN(premium.taxes)}
                                    </Text>
                                    <Text type="label" align="right">
                                      {Util.TRANSFORM.CURRENCY.MXN(premium.subTotal)}
                                    </Text>
                                  </div>
                                )
                              }
                            )
                          }
                        </div>

                        <div className="bill__content__invoice__section__content__summary">
                          <div className="bill__content__invoice__section__content__summary__item">
                            <Text type="paragraph">
                              Subtotal
                            </Text>
                            <Text type="paragraph" bold>
                              {Util.TRANSFORM.CURRENCY.MXN(currentInvoice.netAmount)}
                            </Text>
                          </div>
                          <div className="bill__content__invoice__section__content__summary__item">
                            <Text type="paragraph">
                              IVA (16%)
                            </Text>
                            <Text type="paragraph" bold>
                              {Util.TRANSFORM.CURRENCY.MXN(currentInvoice.taxes)}
                            </Text>
                          </div>
                          <div className="bill__content__invoice__section__content__summary__item">
                            <Text type="subtitle">
                              Total
                            </Text>
                            <Text type="subtitle" bold>
                              {Util.TRANSFORM.CURRENCY.MXN(currentInvoice.getTotal())}
                            </Text>
                          </div>
                        </div>
                      </div>

                    </section>

                    <section className="bill__content__invoice__section">
                      <div className="bill__content__invoice__section__header">
                        <span style={{ backgroundImage: `url(${Util.ASSET.POLICY_SUMMARY_DATA})` }}></span>
                        <h2>Selecciona los Datos de facturación</h2>
                      </div>

                      <div className="bill__content__invoice__section__content">
                        {
                          billList &&
                          <>
                            {
                              billList.length > 0 ?
                                <>
                                  <ul className="bill__content__invoice__section__content__list">
                                    {
                                      billList.map(
                                        (info, index) => {
                                          return (
                                            <li key={`bill-info-${index}`} className="bill__content__invoice__section__content__list__bill-item"
                                              onClick={() => onSelectBillInfo(info)}
                                            >
                                              <div className="bill__content__invoice__section__content__list__bill-item__left">
                                                <Checkbox checked={currentBillInfo ? info.id === currentBillInfo.id : false} readOnly />
                                              </div>

                                              <div className="bill__content__invoice__section__content__list__bill-item__right">
                                                <p className="bill__content__invoice__section__content__list__bill-item__text">
                                                  <b>Correo Electr&oacute;nico:</b> {info.personEmail}
                                                </p>
                                                <p className="bill__content__invoice__section__content__list__bill-item__text">
                                                  <b>RFC:</b> {info.rfc}
                                                </p>
                                                <p className="bill__content__invoice__section__content__list__bill-item__text">
                                                  <b>Nombre:</b> {info.personName}
                                                </p>
                                                <p className="bill__content__invoice__section__content__list__bill-item__text">
                                                  <b>R&eacute;gimen Fiscal:</b> {taxRegimes.find(t => t.id === info.taxRegime?.id)?.description}
                                                </p>
                                                <p className="bill__content__invoice__section__content__list__bill-item__text">
                                                  <b>C&oacute;digo postal:</b> {info.postalCode}
                                                </p>
                                              </div>
                                            </li>
                                          )
                                        }
                                      )
                                    }
                                  </ul>
                                  <div className="bill__content__invoice__section__content__button">
                                    <Button type="button" fill="outline"
                                      onClick={() => setFormVisible(true)}>
                                      + Agregar datos de facturación
                                    </Button>
                                  </div>
                                </>
                                :
                                <>
                                  <div className="bill__content__invoice__section__content__empty">
                                    <span className="bill__content__prompt__image" style={{ backgroundImage: `url(${Util.ASSET.WARNING_IMAGE})` }}></span>
                                    <h2 className="bill__content__prompt__title">A&uacute;n no tienes datos de facturaci&oacute;n</h2>

                                    <div className="bill__content__invoice__section__content__button">
                                      <Button type="button" fill="outline" onClick={() => setFormVisible(true)}>+ Agregar datos de facturación</Button>
                                    </div>
                                  </div>
                                </>
                            }
                          </>
                        }

                      </div>

                      {
                        formVisible &&
                        <BillForm
                          taxRegimes={taxRegimes}
                          totalAmount={currentInvoice.getTotal()}
                          saveData={billList && billList?.length === 0}
                          onClose={() => setFormVisible(false)}
                          onCreate={(form, regime, use) => createInvoiceByForm(form, regime, use)}
                        />
                      }

                    </section>

                    <div className="bill__content__invoice__button-request">
                      <Button type="button"
                        disabled={!currentBillInfo}
                        onClick={() => createInvoiceByBillInfo()}
                      >
                        Facturar compra por {Util.TRANSFORM.CURRENCY.MXN(currentInvoice.getTotal())}
                      </Button>
                    </div>

                    {
                      creating.value &&
                      <div className="bill__content__invoice__creating">
                        <Spinner color="main" relative />
                        <h3>Procesando tu factura...</h3>
                      </div>
                    }

                  </div>
                </>
              }

              {
                invoiceStatus.isExpired() &&
                <>
                  <div className="bill__content__prompt bill__content__prompt--animation">
                    <section className="bill__content__prompt__section bill__content__prompt__section--top">
                      <span className="bill__content__prompt__image" style={{ backgroundImage: `url(${Util.ASSET.WARNING_IMAGE})` }}></span>
                      <h2 className="bill__content__prompt__title">Esta p&oacute;liza ya no est&aacute; disponible para facturaci&oacute;n</h2>
                      <p className="bill__content__prompt__paragraph">Todas las facturas van a poder hacerse dentro del mes en curso.</p>
                    </section>

                    <section className="bill__content__prompt__section bill__content__prompt__section--bottom">
                      <a className="bill__content__prompt__support" target="_blank" rel="noreferrer" href={Util.CONSTANT.WA_SUPPORT}>
                        <span>
                          <p className="bill__content__prompt__paragraph bill__content__prompt__paragraph--main bill__content__prompt__paragraph--bold">¿Necesitas ayuda?</p>
                          <p className="bill__content__prompt__paragraph bill__content__prompt__paragraph--main">Escríbeme ahora</p>
                        </span>
                        <p>🙋‍♀️</p>
                      </a>

                      <p className="bill__content__prompt__paragraph">Ir a <a href="https://crabi.com" target="_self" >crabi.com</a></p>
                    </section>

                  </div>
                </>
              }

              {
                invoiceStatus.isFinished() &&
                <>
                  <div className="bill__content__prompt bill__content__prompt--animation">
                    <section className="bll__content__prompt__section bill__content__prompt__section--top">
                      <span className="bill__content__prompt__image" style={{ backgroundImage: `url(${Util.ASSET.POLICY_INVOICE_FINISHED})` }}></span>
                      <h2 className="bill__content__prompt__title">La compra de la p&oacute;liza <br />{policyNumber}</h2>
                      <p className="bill__content__prompt__paragraph">Ya se encuentra facturada.</p>
                    </section>

                    <section className="bill__content__prompt__section bill__content__prompt__section--bottom">
                      <a className="bill__content__prompt__support" target="_blank" rel="noreferrer" href={Util.CONSTANT.WA_SUPPORT}>
                        <span>
                          <p className="bill__content__prompt__paragraph bill__content__prompt__paragraph--main bill__content__prompt__paragraph--bold">¿Necesitas ayuda?</p>
                          <p className="bill__content__prompt__paragraph bill__content__prompt__paragraph--main">Escríbeme ahora</p>
                        </span>
                        <p>🙋‍♀️</p>
                      </a>

                      <p className="bill__content__prompt__paragraph">Ir a <a href="https://crabi.com" target="_self" >crabi.com</a></p>
                    </section>

                  </div>
                </>
              }

              {
                invoiceStatus.isEmpty() &&
                <div className="bill__content__prompt bill__content__prompt--animation">
                  <section className="bll__content__prompt__section bill__content__prompt__section--top">
                    <span className="bill__content__prompt__image" style={{ backgroundImage: `url(${Util.ASSET.WARNING_IMAGE})` }}></span>
                    <h2 className="bill__content__prompt__title">La p&oacute;liza {policyNumber}</h2>
                    <p className="bill__content__prompt__paragraph">No est&aacute; disponible para ser facturada.</p>
                  </section>

                  <section className="bill__content__prompt__section bill__content__prompt__section--bottom">
                    <a className="bill__content__prompt__support" target="_blank" rel="noreferrer" href={Util.CONSTANT.WA_SUPPORT}>
                      <span>
                        <p className="bill__content__prompt__paragraph bill__content__prompt__paragraph--main bill__content__prompt__paragraph--bold">¿Necesitas ayuda?</p>
                        <p className="bill__content__prompt__paragraph bill__content__prompt__paragraph--main">Escríbeme ahora</p>
                      </span>
                      <p>🙋‍♀️</p>
                    </a>

                    <p className="bill__content__prompt__paragraph">Ir a <a href="https://crabi.com" target="_self" >crabi.com</a></p>
                  </section>

                </div>
              }
            </>
            :
            <Spinner color="main" circles />
        }
      </div>
    </div>
  );
};

export default BillPage;